import React, { useState } from 'react';
import Modal from '../Modal';
import NodementedFunnel from './NodementedFunnel';

/**
 * Modal simple pour le NodementedFunnel avec confirmation de sortie
 * Approche minimale qui ne modifie rien d'existant
 */
const NodementedFunnelModalSimple = ({ isOpen, onClose, ...funnelProps }) => {
  const [showExitConfirm, setShowExitConfirm] = useState(false);

  // Gestionnaire de fermeture avec confirmation
  const handleCloseAttempt = () => {
    setShowExitConfirm(true);
  };

  // Fermeture confirmée
  const handleConfirmedClose = () => {
    setShowExitConfirm(false);
    onClose();
  };

  // Annulation de la fermeture
  const handleCancelClose = () => {
    setShowExitConfirm(false);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Modal principale - utilise Modal existant sans modifications */}
      <Modal 
        open={isOpen && !showExitConfirm} 
        onClose={handleCloseAttempt}
        style={{ maxWidth: '95vw', width: '95vw' }}
      >
        <div style={{ position: 'relative', minHeight: '80vh' }}>
          {/* Bouton de fermeture simple avec confirmation */}
          <button
            onClick={handleCloseAttempt}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 12px',
              cursor: 'pointer',
              fontWeight: 'bold',
              zIndex: 1000,
              fontSize: '14px'
            }}
          >
            ✕ Quitter
          </button>
          
          {/* Le funnel original SANS AUCUNE modification */}
          <NodementedFunnel
            {...funnelProps}
            onFunnelComplete={(data) => {
              // Callback original + fermeture auto après succès
              funnelProps.onFunnelComplete?.(data);
              setTimeout(() => onClose(), 1500);
            }}
          />
        </div>
      </Modal>

      {/* Modal de confirmation simple et minimaliste */}
      {showExitConfirm && (
        <Modal open={true} onClose={handleCancelClose}>
          <div style={{ textAlign: 'center', padding: '30px' }}>
            <div style={{ fontSize: '3rem', marginBottom: '15px' }}>⚠️</div>
            <h3 style={{ margin: '0 0 15px 0', color: '#374151' }}>Quitter le workflow ?</h3>
            <p style={{ margin: '0 0 25px 0', color: '#6b7280' }}>
              Votre progression sera sauvegardée automatiquement.
            </p>
            <div style={{ 
              display: 'flex', 
              gap: '15px', 
              justifyContent: 'center' 
            }}>
              <button
                onClick={handleCancelClose}
                style={{
                  background: '#6b7280',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Continuer le workflow
              </button>
              <button
                onClick={handleConfirmedClose}
                style={{
                  background: '#ef4444',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Quitter malgré tout
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default NodementedFunnelModalSimple;
